<template>
  <div>
    <div class="s-img">
      <img src="../assets/images/index/1-1.jpg" />
    </div>
    <div class="s-video-box">
      <!-- 使用组件 -->
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playersinline="true"
        :options="playerOptions"
      >
      </video-player>
    </div>
    <div class="four-box">
      <div class="i-h" style="font-weight: bold">聚焦驻地充电</div>
      <div class="i-title" style="font-weight: bold">
        提供多场景充电解决方案
      </div>
      <!-- <div class="sixBox-spec">▼</div> -->
      <div class="six-spec-box"></div>
      <div class="four-ul">
        <swiper
          ref="swiperbox"
          :options="swiperOption"
          v-if="swiperList.length > 0"
        >
          <swiper-slide
            class="swiper-item"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <div class="four-cell">
              <img :src="item.url" />
              <div style="text-align: left; padding-left: 30px">
                <div style="font-weight: bold; font-size: 30px">
                  {{ item.title }}
                </div>
                <div style="padding: 10px 0">{{ item.desc }}</div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="f-img-ul">
        <swiper class="swipersBg" ref="swipersbox" :options="swipersOption">
          <swiper-slide
            class="swiper-item"
            v-for="(item, index) in imgList"
            :key="index"
          >
            <div class="f-img-cell" style="padding: 0 1.2rem">
              <el-image
                :src="item.path"
                @click="handleImageClick(index)"
                style="
                  width: 100%;
                  height: 10vw;
                  border-radius: 1.5rem;
                  border: 0.2rem solid #3b56fe;
                "
              ></el-image>
              <!-- <div style="font-weight: bold">{{ item.title }}</div> -->
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-next" slot="button-next">
          <img src="../assets/images/right.png" />
        </div>
        <div class="swiper-button-prev" slot="button-prev">
          <img src="../assets/images/left.png" />
        </div>
      </div>
    </div>
    <div class="fixBox-bg">
      <img src="../assets/images/index/1-1_05.jpg" />
      <div class="fixBox-box" style="color: #424142">
        <div class="fixBox-title">
          看准<span style="font-weight: bold">大趋势</span> 抓住<span
            style="font-weight: bold"
            >真机遇</span
          >
        </div>
        <!-- <div class="fixBox-h">闪开在全国拥有348个城市和150所高等院校，在国内70000+标准场景中，</div>
				<div class="fixBox-h">投放了超过50万台充电桩，已服务数千家物业机构，注册用户数超3000万。</div> -->
        <div class="fixBox-h">
          闪开在国内70000+标准场景中，投放了超过50万台充电桩，
        </div>
        <div class="fixBox-h">已服务数千家物业机构，注册用户数超3000万。</div>
        <div class="sixBox-spec">▼</div>
        <div class="fixBox-btn-bg">
          <div class="fixBox-btn-box" style="color: #fff">
            <div class="fixBox-btn-span" @click="gotoUrl(1)">联系我们</div>
            <div class="fixBox-btn-span">|</div>
            <div class="fixBox-btn-span" @click="gotoUrl(2)">点此合作</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="sixBox-bg">
			<div class="i-h">多品牌战略</div>
			<div class="sixBox-spec">▼</div>
			<div class="sixBox-ul">
				<div class="sixBox-li" @click="goBrand(1)">
					<img src="../assets/images/index/six1.jpg" />
				</div>
				<div class="sixBox-li" @click="goBrand(2)">
					<img src="../assets/images/index/six2.jpg" />
				</div>
				<div class="sixBox-li" @click="goBrand(3)">
					<img src="../assets/images/index/six3.jpg" />
				</div>
			</div>
		</div> -->
    <div class="s-img">
      <img src="../assets/images/index/1-1_07.jpg" />
    </div>
    <div class="s-img">
      <img src="../assets/images/index/1-1_08.jpg" />
    </div>
    <!-- 自定义预览对话框 -->
    <el-dialog :visible.sync="dialogVisible" :width="dialogWidth">
      <img
        :src="currentImage"
        alt="图片预览"
        style="margin: auto; display: block; max-width: 100%; max-height: 100vh"
      />
    </el-dialog>
  </div>
</template>

<script>
// 导入组件
import { videoPlayer } from "vue-video-player";
import "videojs-flash";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    videoPlayer,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      playerOptions: {
        autoplay: true,
        loop: true,
        aspectRatio: "16:9",
        sources: [
          {
            type: "video/mp4",
            src:'https://sk-oss.issks.com/sk/sk.mp4'
            // src: "https://oms.issks.com/media/sk001.mp4",
          },
        ],
      },
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        slidesPerView: 4, //页面中的板块数量
        initialSlide: 1, // 默认展示页
        spaceBetween: 30, // 模块之间的间隔
        freeMode: true, //free模式，slide会根据惯性滑动且不会贴合
        centeredSlides: true,
      },
      swiperList: [
        {
          url: require(`@/assets/images/index/1.png`),
          title: "社区",
          desc: "提供安全、可靠、耐用的场景化解决方案",
        },
        {
          url: require(`@/assets/images/index/2.png`),
          title: "厂区",
          desc: "提供安全、可靠、耐用的场景化解决方案",
        },
        {
          url: require(`@/assets/images/index/3.png`),
          title: "园区",
          desc: "提供安全、可靠、耐用的场景化解决方案",
        },
        {
          url: require(`@/assets/images/index/4.png`),
          title: "景区",
          desc: "提供安全、可靠、耐用的场景化解决方案",
        },
      ],
      swipersOption: {
        loop: false,
        autoplay: false,
        slidesPerView: 5, //页面中的板块数量
        initialSlide: 1, // 默认展示页
        spaceBetween: 5, // 模块之间的间隔
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      imgList: [
        {
          url: require(`@/assets/images/index/g1.png`),
          path: require(`@/assets/images/index/max/max1.jpg`),
          title: "三角家园小区",
        },
        {
          url: require(`@/assets/images/index/g2.png`),
          path: require(`@/assets/images/index/max/max2.jpg`),
          title: "万科咸阳金域缇香",
        },
        {
          url: require(`@/assets/images/index/g3.png`),
          path: require(`@/assets/images/index/max/max3.jpg`),
          title: "森林公园北门停车场车棚",
        },
        {
          url: require(`@/assets/images/index/g4.png`),
          path: require(`@/assets/images/index/max/max4.jpg`),
          title: "河南周口欢乐家园",
        },
        {
          url: require(`@/assets/images/index/g5.png`),
          path: require(`@/assets/images/index/max/max5.jpg`),
          title: "湖北荆门楚荣雅苑充电站",
        },
        {
          url: require(`@/assets/images/index/g6.png`),
          path: require(`@/assets/images/index/max/max6.jpg`),
          title: "重庆巴南区木洞焊管厂充电站",
        },
        {
          url: require(`@/assets/images/index/g7.png`),
          path: require(`@/assets/images/index/max/max7.jpg`),
          title: "白沙金波乡卫生院",
        },
        {
          url: require(`@/assets/images/index/g8.png`),
          path: require(`@/assets/images/index/max/max8.jpg`),
          title: "河北秦皇岛万科公园大道",
        },
        {
          url: require(`@/assets/images/index/g9.png`),
          path: require(`@/assets/images/index/max/max9.jpg`),
          title: "河北秦皇岛万科公园大道",
        },
        {
          url: require(`@/assets/images/index/g10.png`),
          path: require(`@/assets/images/index/max/max10.jpg`),
          title: "河北秦皇岛万科公园大道",
        },
      ],
      currentImage: "",
      dialogVisible: false,
      // 预览对话框宽度，可以根据需要调整
      dialogWidth: "40vw",
    };
  },
  //初始化执行
  mounted() {
    //此处代替onLoad
    var self = this;
  },
  methods: {
    gotoUrl(index) {
      if (index == 2) {
        this.$router.push({ path: "/contact", query: { toPosition: 1 } });
      } else {
        this.$router.push({ path: "/contact" });
      }
    },
    goBrand(index) {
      if (index == 1) {
        this.$router.push({ path: "/brands" });
      } else if (index == 2) {
        this.$router.push({ path: "/brand" });
      } else if (index == 3) {
        this.$router.push({
          path: "/product",
          query: { tabId: 2, productId: 0 },
        });
      }
    },
    //点击预览图片
    handleImageClick(index) {
      const pageWidth = window.innerWidth;
      console.log("=pageWidth=>", pageWidth);
      this.currentImage = this.imgList[index].path;
      this.dialogVisible = true;
      if (pageWidth < 400) {
        this.dialogWidth = "90vw";
      } else {
        this.dialogWidth = "40vw";
      }
    },
  },
};
</script>

<style>
.section {
  height: 100%;
  height: 100%;
}
.four-box {
  margin-top: 1rem;
  padding: 2rem 2%;
  text-align: center;
}
/* =====PC版样式====== */
@media screen and (min-width: 755px) {
  .i-h {
    font-size: 2vw;
    color: #88af51;
  }
  .i-title {
    margin-top: 0.5rem;
    font-size: 2vw;
    color: #88af51;
  }
  .four-ul {
    width: 100%;
    margin-top: 4rem;
    padding-bottom: 2rem;
    overflow: hidden;
    white-space: nowrap;
  }
}

/* ================= */
.swiper-item {
  margin-right: 2.5%;
  padding-bottom: 0.3rem;
}
.four-cell {
  width: 100%;
  box-shadow: 0.1rem 0.1rem 0.8rem 0 rgba(0, 0, 0, 0.2);
  border-radius: 1.2rem;
  overflow: hidden;
}
/* ==================== */
.f-img-ul {
  width: 100%;
  position: relative;
}
.swipersBg {
  width: 98%;
  margin: 0 auto;
}
.swiper-button-next {
  width: 5%;
  color: #fff;
  background-image: none;
  right: -2%;
  top: 58%;
}
.swiper-button-prev {
  width: 5%;
  color: #fff;
  background-image: none;
  left: -2%;
  top: 58%;
}
/* =====PC版样式====== */
@media screen and (min-width: 755px) {
  .swiper-button-next {
    width: 2.5%;
    color: #fff;
    background-image: none;
    right: -1%;
    top: 40%;
  }
  .swiper-button-prev {
    width: 2.5%;
    color: #fff;
    background-image: none;
    left: -1%;
    top: 40%;
  }
}
/* =============== */
.h-btn-to {
  width: 50%;
  height: 8rem;
  cursor: pointer;
  position: absolute;
  top: 25%;
  left: 25%;
}
/* ================ */
.fixBox-bg {
  width: 100%;
  max-height: 43vw;
  overflow: hidden;
  position: relative;
}
.fixBox-box {
  width: 100%;
  color: #fff;
  text-align: center;
  position: absolute;
  top: 6%;
  left: 0;
}
.fixBox-title {
  font-size: 2.5vw;
}
.fixBox-h {
  margin-top: 0.5rem;
  font-size: 1.8vw;
}
.fixBox-btn-bg {
  margin-top: 1vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fixBox-btn-box {
  padding: 0.5vw 2vw;
  background-color: #88af51;
  border-radius: 8vw;
  font-size: 1.5vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fixBox-btn-span {
  padding: 0 0.5rem;
  cursor: pointer;
}
/* =============== */
.sixBox-bg {
  padding: 3vw 0;
}
.sixBox-spec {
  width: 20%;
  margin: 0.5vw auto;
  text-align: center;
  font-size: 1.5vw;
  color: #88af51;
}
.sixBox-ul {
  width: 60%;
  margin: 3vw auto;
  display: flex;
  justify-content: space-between;
}
.sixBox-li {
  width: 28%;
  cursor: pointer;
}
/* ======================= */
/* ================= */
.el-dialog {
  background-color: transparent;
  margin: 0 auto;
}
.el-dialog__headerbtn {
  background-color: #fff;
  border-radius: 50%;
}
/* ====移动端样式==== */
@media screen and (max-width: 750px) {
  .four-box {
    padding: 2rem 2%;
    text-align: center;
    font-size: 1.2rem;
  }
  .i-h {
    color: #88af51;
  }
  .i-title {
    margin-top: 0.5rem;
    font-weight: bold;
    color: #88af51;
  }
  .four-ul {
    width: 100%;
    margin-top: 2rem;
    padding-bottom: 0.5rem;
    overflow: hidden;
    white-space: nowrap;
  }
  .fixBox-box {
    top: 8%;
  }
  .fixBox-title {
    font-size: 1.2rem;
  }
  .fixBox-h {
    margin-top: 0.2rem;
    font-size: 0.8rem;
  }
  .fixBox-btn-bg {
    margin-top: 0.5rem;
  }
  .fixBox-btn-box {
    padding: 0.2rem 0.8rem;
    background-color: #88af51;
    border-radius: 4rem;
    font-size: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sixBox-spec {
    font-size: 0.8rem;
  }
}

.six-spec-box {
  width: 4rem;
  height: 0.3rem;
  border-radius: 1rem;
  margin: 0.5vw auto;
  background-color: #88af51;
}
</style>
